import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import App from "./App";

const container = document.getElementById("root");
const app = (
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// The production build ships prerendered HTML for every route, so hydrate it
// rather than replacing it. In development the container is empty.
if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
